import {Component} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthLoginService} from '../../../auth/auth.service';
import {CPATTERN} from '../../../shared/helpers/app.constants';
import {ToasterService} from '../../../shared/services/toaster.service';

@Component({
  selector: 'app-change-password-profile',
  templateUrl: './change-password-profile.component.html',
  styleUrls: ['./change-password-profile.component.scss']
})
export class ChangePasswordProfileComponent {

  cvalidate = CPATTERN;
  loading: boolean = false;
  submitted: boolean = false;

  form: FormGroup;
  currentPassword: AbstractControl;
  newPassword: AbstractControl;
  confirmPassword: AbstractControl;

  constructor(private formBuilder: FormBuilder,
              private authService: AuthLoginService,
              private toasterService: ToasterService) {
    this.createForm();
  }

  createForm() {
    this.form = this.formBuilder.group({
      currentPassword: new FormControl('', [Validators.required]),
      newPassword: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(100),
        Validators.pattern(this.cvalidate.PASSWORD)])
      ),
      confirmPassword: new FormControl('')
    }, {validator: this.checkIfMatchingPasswords('newPassword', 'confirmPassword')});
    this.currentPassword = this.form.controls['currentPassword'];
    this.newPassword = this.form.controls['newPassword'];
    this.confirmPassword = this.form.controls['confirmPassword'];

  }

  checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      const passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({notEquivalent: true});
      } else if (!passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({required: true});
      } else {
        return passwordConfirmationInput.setErrors(null);
      }
    };
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      this.submitted = true;
      const obj = {
        currentPassword: this.currentPassword.value,
        newPassword: this.newPassword.value
      };
      this.authService.changePasswordProfile(obj, () => {
        this.loading = false;
        this.submitted = false;
        this.form.reset();
      })
        .subscribe(
          (response) => {
            this.toasterService.showSuccess('Updated Successfully');
          });
    }
  }
}
